<template>
    <span style="margin-left: 10px; margin-right: 10px" v-if="readonly">{{
        member && member.Key ? member.RealName : ""
    }}</span>
    <el-select v-else :filterable="true" v-model="member" @change="dataChange" value-key="Key" :clearable="clearable"
        size="small" @clear="dataChange" :disabled="disabled">
        <el-option v-for="item in datas" :key="item.Key" :label="item.RealName+'@'+item.Actor.Name" :value="item">
            <div class="proItem">
                <div class="name">{{ item.RealName }}@{{item.Actor.Name}}</div>
                <!-- <div class="companys">
                    <div class="company">
                        {{ item.Mobile }}
                    </div>
                </div> -->
            </div>
        </el-option>
    </el-select>
</template>
<script>
import { getAll } from "@/api/setting/member";
export default {
    model: {
        prop: "value",
        event: "change",
    },
    props: {
        value: {
            default: "",
        },
        clearable: {
            default: true,
        },
        disabled: {
            default: false,
        },
        memberType: {
            default: "",
        },
        readonly: {
            default: false,
        },
    },
    data() {
        return {
            datas: [],
            member: "",
        };
    },
    watch: {
        value: {
            handler(v) {
                this.member = v;
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        getData() {
            let param = {
                search: "",
                memberType: this.memberType,
            };
            getAll(param).then((res) => {
                if (res) {
                    this.datas = res.Items;
                }
            });
        },
        dataChange(v) {
            this.$emit("change", v);
        },
    },
    mounted() {
        this.getData();
    },
};
</script>
<style lang='scss' scoped></style>